// globals.ts
import {Injectable, OnDestroy} from '@angular/core';
import { BehaviorSubject } from "rxjs/BehaviorSubject";
import { Observable } from "rxjs/Observable";
import {fromEvent} from "rxjs/observable/fromEvent";
import {debounceTime, takeUntil} from "rxjs/operators";
import {Subject} from "rxjs/Subject";

@Injectable()
export class Globals implements OnDestroy {
    private isMobile = new BehaviorSubject(false);
    public screenWidth: string;
    private isSiderBarOpen = new BehaviorSubject(false);
    public screenWidthValue = new  BehaviorSubject(0);

    private destroy$ = new Subject();
    constructor() {
        // if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        //     this.isMobile = true;
        // }

        this.triggerResizeEvent();

    }

    triggerResizeEvent() {
        fromEvent(window, 'resize')
            .pipe(
                debounceTime(700),
                takeUntil(this.destroy$)
            ).subscribe((event: any) => {
            this.checkWidth(event);
        })
    }

    onMobileChange(status: boolean) {
        this.isMobile.next(status);
    }

    getMobileStatus(): Observable<any> {
        return this.isMobile.asObservable();
    }

    onSideBarChange(status: boolean) {
        this.isSiderBarOpen.next(status);
    }

    getSideBarStatus(): Observable<any> {
        return this.isSiderBarOpen.asObservable();
    }

    public checkWidth(event?: any) {
        const width = event ? event.target.innerWidth : window.innerWidth;
        this.screenWidthValue.next(width);
        if (width <= 812) {
            this.screenWidth = 'sm';
            this.onMobileChange(true);
        } else if (width > 812 && width <= 992) {
            this.screenWidth = 'md';
            this.onMobileChange(false);
        } else {
            this.screenWidth = 'lg';
            this.onMobileChange(false);
        }
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }

}



// WEBPACK FOOTER //
// C:/Users/beyn/Documents/GitLab/spinmatic-casino/src/app/globals.ts